// Site-wide config for Rubiemaze Inc.
export const BRAND = {
  name: "Rubiemaze Inc",
  founder: "Ritesh Sikri",
  tagline: "India's Leading Nightlife Consultant",
  instagram: "https://instagram.com/ritzzze.official",
  instagramHandle: "@ritzzze.official",
  email: "ritzzze@lalaa.in",
  whatsappNumber: "+919830134891",
  whatsappDisplay: "+91 98301 34891",
  whatsappUrl:
    "https://wa.me/919830134891?text=Hi%20Ritesh%2C%20I%27d%20like%20to%20talk%20about%20my%20venue.",
};

// Add real Instagram Reel URLs here. Format:
//   "https://www.instagram.com/reel/{REEL_ID}/"
//   "https://www.instagram.com/p/{POST_ID}/"
// Cards fall back to poster images + a "Watch on Instagram" link.
export const INSTAGRAM_REELS = [
  {
    url: "https://www.instagram.com/reel/DalB0SOs9FV/",
    poster:
      "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?auto=format&fit=crop&w=800&q=80",
    caption: "From the console.",
  },
  {
    url: "https://www.instagram.com/reel/Dahxraaxx9G/",
    poster:
      "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?auto=format&fit=crop&w=800&q=80",
    caption: "Field notes.",
  },
  {
    url: "https://www.instagram.com/reel/DaVGK1qPkZ1/",
    poster:
      "https://images.unsplash.com/photo-1514933651103-005eec06c04b?auto=format&fit=crop&w=800&q=80",
    caption: "On the floor.",
  },
  {
    url: "https://www.instagram.com/reel/DaDAItgx6sW/",
    poster:
      "https://images.unsplash.com/photo-1541532713592-79a0317b6b77?auto=format&fit=crop&w=800&q=80",
    caption: "Behind the venue.",
  },
  {
    url: "https://www.instagram.com/reel/DZpGg-yxCWG/",
    poster:
      "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?auto=format&fit=crop&w=800&q=80",
    caption: "Nightlife economics.",
  },
  {
    url: "https://www.instagram.com/reel/DZcGrMmRiCl/",
    poster:
      "https://images.unsplash.com/photo-1445510861639-5651173bc5d5?auto=format&fit=crop&w=800&q=80",
    caption: "Operator notes.",
  },
];

// Instagram post used as a secondary embed (currently unused — we use the
// customer-provided portrait photo below).
export const ABOUT_INSTAGRAM_POST =
  "https://www.instagram.com/p/DaK8QusxhHA/";

// Portrait shown in the About section.
export const ABOUT_PORTRAIT =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_nightlife-elite/artifacts/ra5yfs5e_Moody%20monochrome%20portrait%20of%20man%20%281%29.png";

// Hero uses layered cinematic images with a slow Ken-Burns motion loop.
// Every URL is verified live.
export const HERO_IMAGES = [
  "https://images.unsplash.com/photo-1470225620780-dba8ba36b745?auto=format&fit=crop&w=1920&q=85",
  "https://images.unsplash.com/photo-1543007630-9710e4a00a20?auto=format&fit=crop&w=1920&q=85",
  "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?auto=format&fit=crop&w=1920&q=85",
];
